export default {
    getCarouselIndex(state) {
        return state.carousel_index;
    }
}
